var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-consulta-rfc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "consulta-rfc",
    clipPath: "url(#clip-consulta-rfc)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2314",
    "data-name": "Grupo 2314",
    transform: "translate(-730.921 -472.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(734.924 476.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 92,
    height: 92,
    transform: "translate(-0.001 0)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.508 1.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d7bf3bc5-7c8e-464c-8857-4414ee953612",
    d: "M77.615,49.726A27.03,27.03,0,0,0,39.39,11.5L9,41.893V80.164H47.269Z",
    transform: "translate(4.51 -3.583)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "de8a9767-a4d6-4216-bf56-7370c732091e",
    x1: 63.035,
    y2: 63.035,
    transform: "translate(0 27.053)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "d904bb01-ebaf-46ac-9bb3-4d0746ab8c0c",
    x1: 38.271,
    transform: "translate(31.517 58.57)",
    fill: "none",
    stroke: "#c9c9c9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRfc);
export default __webpack_public_path__ + "static/media/search-rfc.413145b7e84c71b8756e2da2a7858e3e.svg";
export { ForwardRef as ReactComponent };